import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import type { FallbackProps } from "react-error-boundary";
import styles from "./styles.module.css";
export const DefaultError: React.FC<FallbackProps> = t0 => {
  const $ = _c(6);
  const {
    resetErrorBoundary
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== resetErrorBoundary || $[1] !== router) {
    t1 = async () => {
      const currentPath = router.pathname;
      if (currentPath.startsWith("/assessment/confirm")) {
        router.push("/");
        resetErrorBoundary();
      } else {
        router.reload();
      }
    };
    $[0] = resetErrorBoundary;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const reload = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography variant="h5">ブラウザをリロードして再度お試しください。<br />しばらく経っても復旧しない場合は、お手数ですが担当者までご連絡ください。</Typography>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== reload) {
    t3 = <div className={styles.root}><div className={styles.notification_container}>{t2}<Button variant="contained" color="primary" className={styles.button} onClick={reload}>リロードする</Button></div></div>;
    $[4] = reload;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};